import { CSSProperties } from 'react';

export type Currency = 'GBP' | 'USD' | 'CAD' | 'EUR';

export interface MoneyProps {
  amount: number | null | undefined;
  ccy?: Currency | string;
  muted?: boolean;
  style?: CSSProperties;
}

const SYMBOLS: Record<string, string> = {
  GBP: '£',
  USD: '$',
  CAD: 'CA$',
  EUR: '€',
};

export function Money({ amount, ccy = 'GBP', muted = false, style }: MoneyProps) {
  const value = typeof amount === 'number' && Number.isFinite(amount) ? amount : 0;
  const sym = SYMBOLS[ccy] ?? '';
  const neg = value < 0;
  const abs = Math.abs(value);
  const s = abs.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return (
    <span
      className="ds-num"
      style={{ ...(muted ? { color: 'var(--ink-500)' } : null), ...style }}
    >
      {neg ? '−' : ''}
      {sym}
      {s}
    </span>
  );
}

export default Money;
